export default __webpack_public_path__ + "static/media/Icons_Add Customer Icon.aeba0a76.svg";